import { RoleListView } from '../../../components/Role';
import { UserType } from '../../../types';

export function InternalUserRoles() {
  return <RoleListView type={UserType.Internal} />;
}
